import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { DIVISIBILITY_RULES } from "./rules";

// Controlled divisibility-rule modal for today's divisor.
export default function DivisibilityInfo({ open, onOpenChange, divisor }) {
  const info = DIVISIBILITY_RULES[divisor];

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md rounded-xl" data-testid="divisibility-modal">
        <DialogHeader>
          <DialogTitle className="text-2xl font-semibold tracking-tight">
            {info?.title}
          </DialogTitle>
          <DialogDescription className="sr-only">
            Divisibility rule explanation
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 pt-1">
          <p className="text-base leading-relaxed text-[var(--numex-ink)]">{info?.rule}</p>
          <div className="rounded-lg bg-[#f3f2ec] px-4 py-3">
            <p className="text-xs uppercase tracking-widest text-[var(--numex-muted)] mb-1">
              Example
            </p>
            <p className="text-sm leading-relaxed text-[var(--numex-ink)]">{info?.example}</p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
